import PropTypes from "prop-types";
import {useParams} from "react-router-dom";
import Content from "components/helpers/action-text/content";
import Loading from "components/pages/loading";
import {isBlankHTML} from "lib/ext/string";
import useUnknown from "lib/hooks/use-unknown";
import Links from "./links";

function Answer({id = null}) {
  const params = useParams();
  const unknown = useUnknown(id || params.id);

  if(!unknown) { return <Loading />; }

  const answers = unknown.questions.map(({answer}) => answer).filter((html) => !isBlankHTML(html));
  const answer = params.index ? answers[+params.index - 1] : answers[0];

  return (
    <div className="max-w-screen-md mx-auto">
      <h1>Answer</h1>
      <div className="custom-html">
        <Content className="mb-4" html={answer || "There is no answer yet for this unknown"} />
      </div>
      <Links />
    </div>
  );
}

Answer.propTypes = {id: PropTypes.number};

export default Answer;
